import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'preferences-assessment',
    templateUrl: './preferences-assessment.component.html',
    styleUrls: ['./preferences-assessment.component.css']
})
export class UnitOneLessonTwoPreferencesAssessmentComponent {

    title: string = "Preferences Assessment";
    pageTitle: string = this.title + " | Unit 1, Lesson 2 | T-Folio";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
